export default "__VITE_ASSET__hbPsmml8__"